<template>
  <div class="home-container">
    <HeroSection />
    <div class="section-wrapper hero-products-gap">
      <NewProducts />
    </div>
    <div class="section-wrapper">
      <ShopCategories />
    </div>
    <div class="section-wrapper">
      <BrandLogos />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<script setup>
import HeroSection from '@/components/home/HeroSection.vue'
import ShopCategories from '@/components/home/ShopCategories.vue' // Updated path
import NewProducts from '@/components/home/NewProducts.vue'
import BrandLogos from '@/components/home/BrandLogos.vue'
</script>

<style>
/* Styles to control the spacing between the sections */
.home-container {
  display: flex;
  flex-direction: column;
}

.section-wrapper {
  margin-top: -40px; /* Negative spacing to bring the sections closer on mobile */
}

/* Special spacing between HeroSection and NewProducts */
.hero-products-gap {
  margin-top: 20px; /* Positive spacing to separate HeroSection and NewProducts on mobile */
}

@media (min-width: 768px) {
  .section-wrapper {
    margin-top: 0; /* Restores the normal spacing on desktop */
  }

  /* On desktop we do not need any special spacing */
  .hero-products-gap {
    margin-top: 0;
  }
}
</style>
